export default __webpack_public_path__ + "static/media/horens.082955d7.png";